import React from "react";

const OverlayCard = ({ title, subtitle, image }) => {
  return (
    <div
      className="relative w-full max-w-sm h-80 sm:h-96 rounded-3xl overflow-hidden shadow-md transform transition-all duration-300 hover:scale-105 hover:shadow-2xl group my-2 px-0"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex flex-col justify-center items-center text-center px-6">
        <h3 className="text-2xl sm:text-3xl font-bold text-white leading-tight font-sans mb-4 group-hover:tracking-wide transition-all duration-300 h-28 flex items-center justify-center">
          {title}
        </h3>
        <p className="text-base sm:text-lg text-white font-sans">{subtitle}</p>
      </div>
    </div>
  );
};

export default OverlayCard;
